/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Risk_Mod_FreshInputs */

const en_coach_risk_mod_fresh = /** @type {(inputs: Coach_Risk_Mod_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are well-rested, but your training has ramped up faster than usual. You can still perform well, but monitor for early signs of strain. Avoid stacking another big increase this week.`)
};

const de_coach_risk_mod_fresh = /** @type {(inputs: Coach_Risk_Mod_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gut erholt, aber dein Training hat sich schneller als üblich gesteigert. Du kannst noch gut performen — achte aber auf frühe Warnsignale. Keine weitere große Steigerung diese Woche.`)
};

/**
* | output |
* | --- |
* | "You are well-rested, but your training has ramped up faster than usual. You can still perform well, but monitor for early signs of strain. Avoid stacking ano..." |
*
* @param {Coach_Risk_Mod_FreshInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_risk_mod_fresh = /** @type {((inputs?: Coach_Risk_Mod_FreshInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Risk_Mod_FreshInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_risk_mod_fresh(inputs)
	return de_coach_risk_mod_fresh(inputs)
});